import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function usePrepaidGiftDetail(id: string) {
    const { t } = useTranslation('prepaidCard');
    const { pop } = useFlow();
    const { data, status } = useQuery(userPrepaidCardQueries.giftBox(id));

    useEffect(() => {
        if (status === 'error') {
            toast.error(t('giftDetail.loadError'));
            pop();
        }
    }, [status, t, pop]);

    return {
        gift: data,
        isLoading: status === 'pending',
    };
}

export default usePrepaidGiftDetail;
